import router from './index';
import routeName from './constant';
import store from '@/store';

router.beforeEach((to, from, next) => {
    const {
        metaTitle,
        auth,
        code,
    } = to.meta;
    const isLogin = store.state.permissions.authExternal;

    window.document.title = metaTitle;
    const keepAuthList = [
        routeName.NOTFOUND,
    ];

    const keepAuthListIndex = keepAuthList.findIndex(i => i === to.name);
    if (from.meta.code === code) {
        next();
    } else if (!auth || keepAuthListIndex > -1) {
        next();
    } else if (auth) {
        if (isLogin !== 'Y') {
            sessionStorage.clear();
            router.push({ name: routeName.NO_AUTH });
        }
        // if (store.state.permissions.transactionId) {
        //     next();
        // } else {
        //     router.push({ name: from.meta.backPage || backPage });
        // }
        next();
    } else {
        next();
    }
});

router.afterEach(() => {
});

export default router;
